/**
 * Qué oferta del pack de 1 minuto (`trial_1min`) le corresponde a esta cuenta.
 *
 * **Un solo valor, no dos booleanos.** «Encendido», «restringido por país» y
 * «sin restricciones» son tres respuestas a la MISMA pregunta, y como booleanos
 * independientes admiten combinaciones que no significan nada (¿sin
 * restricciones pero apagado?). El estado imposible desaparece al hacerlo un
 * tipo cerrado: `'catalog'` no puede convivir con `'off'`.
 *
 * Lo resuelve siempre el servidor (`resolveOneMinutePackOffer`): dos de los tres
 * factores —el país de la petición y si esta cuenta ya lo compró— el cliente no
 * puede conocerlos. El paywall recibe el veredicto y lo obedece.
 */
export const ONE_MINUTE_PACK_OFFERS = ['off', 'rescue', 'catalog'] as const

export type OneMinutePackOffer = (typeof ONE_MINUTE_PACK_OFFERS)[number]

/**
 * - `off`: no se ofrece — retirado, país excluido, o ya comprado.
 * - `rescue`: oferta de rescate (default). Solo para quien se queda a cero
 *   minutos con un único hijo, y tras una señal de indecisión.
 * - `catalog`: una opción más del paywall, visible al abrir para cualquiera.
 */
const OFFERS: ReadonlySet<string> = new Set(ONE_MINUTE_PACK_OFFERS)

/**
 * Normaliza lo que llega por el cable. Fail-closed a `'off'`: un snapshot viejo,
 * una respuesta recortada o un valor que no reconocemos no son permiso para
 * vender, y callar es exactamente el comportamiento previo a que el pack
 * existiera.
 */
export function parseOneMinutePackOffer(value: unknown): OneMinutePackOffer {
  return typeof value === 'string' && OFFERS.has(value)
    ? (value as OneMinutePackOffer)
    : 'off'
}
